/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_CHEVRON_RIGHT, ICON_LANGUAGE, SdsIcon } from '@squiz/sds';
import { replaceTenantParam } from 'apps/console-core/src/Utilities/ReplaceTenantParam/ReplaceTenantParam';
import { screenPaths } from 'apps/monitoring/src/Constants/ScreenPaths.constants';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MonitoringSiteListItemProps } from './MonitoringSiteListItem.props';

export const MonitoringSiteListItem = ({ url }: MonitoringSiteListItemProps): JSX.Element => {
  const navigableURL = replaceTenantParam(screenPaths.experienceMonitoringDomainPage.replace(':url', btoa(url)));

  const navigate = useNavigate();
  const handleNavigation = useCallback((): void => {
    navigate(navigableURL);
  }, [navigableURL, navigate]);

  return (
    <button className="monitoring__list-item" data-target={navigableURL} onClick={handleNavigation}>
      <SdsIcon classes="site-icon" svg={ICON_LANGUAGE} />
      <div className="monitoring__list-item-link">
        <span className="truncate">{url}</span>
      </div>
      <SdsIcon classes="chevron" svg={ICON_CHEVRON_RIGHT} />
    </button>
  );
};
